// theme.js
import { createTheme } from "@mui/material/styles";

// Dark Theme
const darkTheme = createTheme({
  palette: {
    primary: {
      main: "#FF8200", // Zenzero Orange
      gradient: "linear-gradient(to left, #ff8300, #ff4700)",
    },
    secondary: {
      main: "#06AEF4", // Cloud Blue
    },
    error: {
      main: "#98e0ff", // Fiji Blue
    },
    warning: {
      main: "#9B27B0", // Cancel color
    },
    info: {
      main: "#FDFEFE", // Ice White
    },
    success: {
      main: "#247BA0", // Oceania
      text: "#FDFEFE",
    },
    background: {
      default: "#164E65", // Light background for light mode
    },
  },
});

// Light theme
const lightTheme = createTheme({
  palette: {
    primary: {
      main: "#FE5F55",
      gradient: "linear-gradient(to right, #E0F9F3, #C5F4E0)",
    },
    secondary: {
      main: "#FFC43D", // Foam
    },
    error: {
      main: "#164E65", // Ink
    },
    warning: {
      main: "#688B58", // Moss
    },
    info: {
      main: "#FDFEFE", // Ice White
    },
    success: {
      main: "#C5F4E0",
      text: "#688B58",
    },
    background: {
      default: "#FFC43D",
    },
  },
});

export { darkTheme, lightTheme };
